import React from "react";
import { InputJson } from "../../../../nq-component";
import InquiriesAddFormPresenter from "./InquiriesAddFormPresenter";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navbar";
import FormFactory from "../../../../components/FormFactory";

class InquiriesAddFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = { object: {}, advanced: false };
    this.presenter = new InquiriesAddFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
    );
  }

  getCollectionName() {
    return "inquiries";
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onClickClient() {
    this.navigateTo(`/client/form`);
  }

  render() {
    const object = this.state.object;
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const label = this.getObjectId() === undefined ? "Create " : "Edit ";
    return (
      <>
        <NavBar
          action={() => (
            <div className="dropdown dropstart d-inline-block">
              <i
                role="button"
                data-bs-toggle="dropdown"
                className="bi bi-three-dots-vertical"
              ></i>
              <div className="dropdown-menu fs-xs">
                <button
                  onClick={this.onClickAdvance.bind(this)}
                  className="dropdown-item py-3"
                >
                  <i className="bi bi-gear pe-2" />
                  Toggle Advance
                </button>
              </div>
            </div>
          )}
        />
        <div className="overflow-auto">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <div className="d-flex align-items-start mt-3">
                <i
                  className="bi bi-chevron-left"
                  style={{ fontSize: "1.5rem" }}
                  onClick={this.onClickBack.bind(this)}
                ></i>
                <h1 className="fw-bold text-capitalize">
                  {" "}
                  {label + (schema.label || this.getCollectionName())}
                </h1>
              </div>
              <div className="mt-3 bg-white border border-gray rounded p-3 px-lg-5 py-lg-4">
                <form onSubmit={this.onSubmitForm.bind(this)}>
                  <div className="row g-3">
                    <div className="col-12">
                      <FormFactory
                        schema={schema}
                        object={object}
                        onChange={this.onChange.bind(this)}
                        excludeFields={[
                          "logo",
                          "checkbox",
                          "second_logo",
                          "status",
                          "payment_term",
                          "unit_type",
                          "unit",
                          "unit_view",
                          "floor_area",
                          "balcony",
                          "gross_floor_area",
                          "unit_type_discount",
                          "launch_discount",
                          "equity",
                          "reservation_fee",
                          "monthly_amortization",
                          "retention",
                          "closing_fee",
                          "gross_unit_price",
                          "link",
                          "reason",
                        ]}
                      />
                      <button
                        type="button"
                        className="btn btn-primary fs-sm fw-bolder mt-3 text-black"
                        onClick={this.onClickClient.bind(this)}
                      >
                        Add Client
                      </button>
                    </div>
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChange.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <FormFactory
                        schema={schema}
                        object={object}
                        onChange={this.onChange.bind(this)}
                        excludeFields={["client", "status", "link", "reason"]}
                      />
                    )}
                  </div>
                  <div className="mt-4 d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn btn-light fs-sm me-3 w-50 fw-bolder"
                      onClick={this.onClickBack.bind(this)}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary fs-sm w-50 fw-bolder text-black"
                    >
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(InquiriesAddFormPage);
